import React, {Component} from 'react';
import cx from 'classnames';
import I18n from 'app/common/i18n';
import * as enums from 'app/utils/enums';

// import Card from 'react-material-card';
import CheckIcon from 'app/assets/done.svg';
import ErrorIcon from 'app/assets/error.svg';

import CompanyInfo from './CompanyInfo';
import LoginInfo from './LoginInfo';
import {Button, SelectField} from 'dk-ui-lib';
import OnboardHeader from 'views/common/OnboardHeader';

import _ from 'lodash';

class CompanyOnboardView extends Component {

  constructor(props) {
    super(props);
    this.state = {
      showStatus: false
    };
  }

  renderAssessmentsPurchasedDropDown() {
    let {entity, company, updateCompanyAssessmentPurchased} = this.props;
    let shouldShowAssessmentPurchasedError = this.state.showStatus && company.errors && company.errors.assessmentsPurchased;
      return (
        <div className='clearfix col-7 mt3'>
          <div className='col-5 clearfix'>
            <div className='field-heading mb2'>{`${I18n.t('onboard.academy.assessments')} ${I18n.t('onboard.academy.purchased')}`}</div>
            <SelectField
              clearable={false}
              labelKey='value'
              valueKey='value'
              placeholder=''
              className={cx({'error': shouldShowAssessmentPurchasedError})}
              options={entity.assessmentsPurchaseList} 
              value={company.assessmentsPurchased}
              onChange={(value) => updateCompanyAssessmentPurchased(value.value)} />
          </div>
          <div className={cx('col-5 red pt1 h6', {'col-1': shouldShowAssessmentPurchasedError, 'hide': !shouldShowAssessmentPurchasedError})}>
            {I18n.t('errors.academy.assessments_purchased')}
          </div>
        </div>
      );
  }

  render() {
    let {
      company,
      updateCompanyName,
      updateCompanyLoginEmail,
      updateCompanyLoginName
    } = this.props;

    let companyInfo = _.omit(company, ['logins', 'errors']);
    companyInfo.errors = _.omit(company.errors, ['logins']);

    let logins = company.logins;
    logins.errors = undefined;
    if (company.errors) {
      if (company.errors.logins) {
        logins.errors = company.errors.logins
      } else if (company.errors['login.email'] || company.errors['login.name']) {
        logins.errors = [{email: company.errors['login.email'], name: company.errors['login.name']}];
      }    
    }

    return (
      <div>
        <OnboardHeader selectedOnboard={enums.onboard_options.COMPANY} placeholder={''}/>
        <div level={1} className='mt2 px3 py2 white-background'>
          <div className='mt2 h3 black bold'>{`${I18n.t('onboard.onboarding')} ${I18n.t('onboard.company.company')}`}</div>
          <CompanyInfo
            className='mt2'
            company={companyInfo}
            updateCompanyName={updateCompanyName}
            showStatus={this.state.showStatus}
          />
          <div>{this.renderAssessmentsPurchasedDropDown()}</div>
          <LoginInfo
            company={logins}
            updateCompanyLoginEmail = {updateCompanyLoginEmail}
            updateCompanyLoginName = {updateCompanyLoginName}
            showStatus={this.state.showStatus}
          />
          <div className='mt3 flex justify-between'>
            <div>
            </div>
            <div>
              <Button
                onClick={() => this.handleCreate()}
                type='primary'
                buttonStyle={{padding: '0.75rem'}}
                labelStyle={{fontSize: '0.9rem'}}
                icon={<CheckIcon/>}
                label={I18n.t('onboard.create')}/>
            </div>
          </div>
        </div>
      </div>  
    );
  }

  handleCreate() {
    let {handleCreateCompany} = this.props;
    this.setState({ showStatus: true  });
    handleCreateCompany();
  }

  shouldRenderErrorLegend(companyInfo, logins) {
    return this.state.showStatus &&
      (!_.isEmpty(companyInfo.errors) || !_.isEmpty(logins.errors))
  }

  renderError() {
    return (
      <div className='flex items-center app-error h6 p1'>
        <ErrorIcon/>
        <div className='pl1'>
          {I18n.t('errors.requiredFields')}
        </div>

      </div>
    );
  }
}

export default CompanyOnboardView;


// WEBPACK FOOTER //
// ./src/views/company-onboard/index.js